import {constants} from '@newsela/angelou';
import {css} from 'emotion';

const coreBlue = constants.colors.ui.coreBlue[500];

const diameter = '2.5rem';
export const avatarBadge = css({
  width: diameter,
  height: diameter,
  borderRadius: '50%',
  border: `solid 2px ${coreBlue}`,
  display: 'inline-flex',

  alignItems: 'center',
  justifyContent: 'center',

  fontFamily: 'Circular',
  fontWeight: 'bold',
  fontSize: '12px',
  textAlign: 'center',
  textTransform: 'uppercase',
  color: coreBlue
});
